import React from 'react';
import '../styles/AboutPage.css';

const About = () => {
  // Phone number
  const phoneNumber = '+918019472678';

  const features = [
    {
      icon: '🛏️',
      title: '10+ Luxury Rooms',
      description: 'Well-furnished rooms with modern amenities for a comfortable stay'
    },
    {
      icon: '📍',
      title: 'Prime Location',
      description: 'Located in the heart of Hyderabad at Ameerpet, near all major attractions'
    },
    {
      icon: '⭐',
      title: '5-Star Service',
      description: '24/7 dedicated staff ensuring your comfort and satisfaction'
    },
    {
      icon: '🚗',
      title: 'Free Parking',
      description: 'Complimentary valet parking for all our guests'
    },
    {
      icon: '💕',
      title: 'Couple Friendly',
      description: '100% privacy guaranteed for couples and romantic getaways'
    },
    {
      icon: '⏰',
      title: 'Short Stays',
      description: 'Flexible 4-hour stay packages available at special rates'
    }
  ];

  const stats = [
    { number: '10+', label: 'Luxury Rooms' },
    { number: '500+', label: 'Happy Guests' },
    { number: '4.8', label: 'Guest Rating' },
    { number: '10+', label: 'Years of Excellence' }
  ];

  // Handle phone call
  const handleCall = () => {
    window.location.href = `tel:${phoneNumber}`;
  };

  return (
    <div className="abt-page-wrapper">
      {/* Hero Banner */}
      <div className="abt-hero-section">
        <div className="abt-hero-overlay">
          <div className="abt-hero-content">
            <span className="abt-hero-badge">✦ About Us</span>
            <h1 className="abt-hero-title">
              Welcome to <span className="abt-hero-highlight">AA GRAND HOTEL</span>
            </h1>
            <p className="abt-hero-subtitle">
              Where luxury meets hospitality in the heart of Hyderabad
            </p>
          </div>
        </div>
      </div>

      {/* About Content */}
      <div className="abt-content-section">
        <div className="abt-container">
          {/* About Story */}
          <div className="abt-story-wrapper">
            <div className="abt-story-image">
              <img 
                src="https://images.unsplash.com/photo-1566073771259-6a8506099945?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" 
                alt="AA GRAND HOTEL"
              />
              <div className="abt-story-badge">
                <span>🏆</span>
                <div>
                  <strong>10+ Years</strong>
                  <p>Of Excellence</p>
                </div>
              </div>
            </div>
            <div className="abt-story-content">
              <span className="abt-story-badge-label">✦ Our Story</span>
              <h2 className="abt-story-title">
                Experience the <span className="abt-highlight">AA GRAND</span> Difference
              </h2>
              <p className="abt-story-description">
                Nestled in the vibrant heart of Hyderabad, AA GRAND HOTEL redefines luxury 
                with its perfect blend of contemporary elegance and timeless hospitality. 
                Every corner of our hotel tells a story of comfort, every smile of our staff 
                reflects warmth, and every stay becomes a cherished memory.
              </p>
              <p className="abt-story-description">
                Whether you're visiting for business or leisure, our meticulously designed 
                rooms, world-class amenities, and prime location near Ameerpet Metro, 
                Banjara Hills, and Gachibowli ensure an experience that goes beyond just a stay.
              </p>
              <div className="abt-story-features">
                <div className="abt-story-feature">
                  <span className="abt-feature-icon">💎</span>
                  <div>
                    <h4>Premium Quality</h4>
                    <p>Uncompromising standards in every aspect</p>
                  </div>
                </div>
                <div className="abt-story-feature">
                  <span className="abt-feature-icon">🤝</span>
                  <div>
                    <h4>Warm Hospitality</h4>
                    <p>Personalized service that makes you feel at home</p>
                  </div>
                </div>
                <div className="abt-story-feature">
                  <span className="abt-feature-icon">📍</span>
                  <div>
                    <h4>Perfect Location</h4>
                    <p>Ameerpet Metro Pillar No. 1072, Hyderabad</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Stats Section */}
          <div className="abt-stats-section">
            {stats.map((stat, index) => (
              <div className="abt-stat-item" key={index}>
                <span className="abt-stat-number">{stat.number}</span>
                <span className="abt-stat-label">{stat.label}</span>
              </div>
            ))}
          </div>

          {/* Features Grid */}
          <div className="abt-features-section">
            <div className="abt-features-header">
              <span className="abt-features-badge">✦ Premium Amenities</span>
              <h2 className="abt-features-title">
                Why Choose <span className="abt-highlight">AA GRAND HOTEL</span>
              </h2>
              <p className="abt-features-subtitle">
                We offer everything you need for a comfortable and memorable stay
              </p>
            </div>

            <div className="abt-features-grid">
              {features.map((feature, index) => (
                <div className="abt-feature-card" key={index}>
                  <div className="abt-feature-icon-wrapper">
                    <span className="abt-feature-icon-large">{feature.icon}</span>
                  </div>
                  <h3>{feature.title}</h3>
                  <p>{feature.description}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Location Section */}
          <div className="abt-location-section">
            <div className="abt-location-content">
              <span className="abt-location-badge">📍 Find Us</span>
              <h2 className="abt-location-title">
                Visit <span className="abt-highlight">AA GRAND HOTEL</span>
              </h2>
              <p className="abt-location-address">
                Ameerpet Metro Pillar No. 1072,<br />
                Above Bata Showroom, First Floor,<br />
                Hyderabad, Telangana
              </p>
              <div className="abt-location-actions">
                <a 
                  href="https://maps.google.com/maps?q=Ameerpet+Metro+Pillar+No+1072+Hyderabad" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="abt-location-btn"
                >
                  🗺️ Get Directions
                </a>
                <button onClick={handleCall} className="abt-location-btn primary">
                  📞 Call Now
                </button>
              </div>
            </div>
            <div className="abt-location-map">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.123456789012!2d78.456789!3d17.456789!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTfCsDI3JzI0LjQiTiA3OMKwMjcnMjQuMCJF!5e0!3m2!1sen!2sin!4v1234567890123"
                width="100%"
                height="300"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="AA GRAND HOTEL Location"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;